import { createResource, type RouteResource } from 'react-resource-router';

import type { ResourceDependencies } from '../../../common/types';
import { getMyTeamsEndpoint } from '../../endpoints/my-teams';
import type { MyTeamsResponse } from '../../endpoints/my-teams/types';

export const createMyTeamsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
): RouteResource<MyTeamsResponse | null> =>
	createResource({
		type: 'myTeamsResource',
		getKey: () => 'myTeamsResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getMyTeamsEndpoint();
		},
		isBrowserOnly: true,
		depends,
	});
